import { cn } from "@/lib/utils";

/**
 * Dekorativní vrstva: statický grain (feTurbulence data-URI) + vinětace.
 * Vždy aria-hidden, nikdy neanimovaný, nikdy nekonkuruje textu.
 */
export function Grain({ className }: { className?: string }) {
  return (
    <div aria-hidden="true" className={cn("pointer-events-none absolute inset-0 z-[1]", className)}>
      <div className="grain-overlay" />
      <div className="vignette-overlay" />
    </div>
  );
}
